import { InputText } from "primereact/inputtext"
import gpraStyles from "../../../styles/Participant-GPRA.module.css"

const FormText = (props) => {
  const {
    error,
    disabled,
    placeholder,
    value,
    setValue,
    removeError,
    errorType,
  } = props
  return (
    <InputText
      className={error ? gpraStyles.inputText5Error : gpraStyles.inputText5}
      disabled={disabled}
      placeholder={placeholder && "Not Applicable"}
      value={value}
      onChange={(e) => {
        setValue(e.target.value)
        removeError(errorType)
      }}
    />
  )
}
export default FormText
